import {
    createBaseQueries,
    transformErrorResponse,
    transformSuccessResponse,
    transformRequest,
    buildFormData,
    EXTERNAL_URL
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const { rawExternalApiBaseQuery: skillPassportBaseQuery } = createBaseQueries({
    externalURLType: EXTERNAL_URL.commonService,
});

const externalSkillPassportAPI = createApi({
    baseQuery: skillPassportBaseQuery,
    reducerPath: 'externalSkillPassportAPI',
    endpoints: (builder) => ({

        achievementExtraction: builder.mutation({
            query: ({ skillCertificate, isRawResponse = true }) => {
                return {
                    url: '/extract',
                    method: 'POST',
                    body: buildFormData({ skillCertificate }),
                    isRawResponse
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAnnouncements: builder.mutation({
            query: (data) => {
                return {
                    url: '/announcements',
                    method: 'POST',
                    body: transformRequest(data)
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getGovernmentSchemes: builder.mutation({
            query: (data) => {
                return {
                    url: '/government-announcements',
                    method: 'POST',
                    body: transformRequest(data)
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getStudentEvents: builder.mutation({
            query: (data) => {
                return {
                    url: '/student-events',
                    method: 'POST',
                    body: transformRequest(data)
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getStudentInternships: builder.mutation({
            query: (data) => {
                return {
                    url: '/internships',
                    method: 'POST',
                    body: transformRequest(data)
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        })

    }),
});

export const {
    useAchievementExtractionMutation, useGetAnnouncementsMutation,
    useGetGovernmentSchemesMutation, useGetStudentEventsMutation,
    useGetStudentInternshipsMutation
} = externalSkillPassportAPI;

export default externalSkillPassportAPI;
